// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__3j_Rj","resendInfoText":"OnGoingPaymentBox_resendInfoText__2GyKF"};